import Vue from 'vue';

const requireComponent = require.context(
    // The relative path of the components folder
    './components/builders',
    // Whether or not to look in subfolders
    true,
    // The regular expression used to match base component filenames
    /[A-Z]\w+\.(vue|js|ts)$/
);

function registerComponents() {
    requireComponent.keys().forEach(fileName => {
        // Get component config
        const componentConfig = requireComponent(fileName);

        // Get PascalCase name of component
        const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1').replace('/', '');

        // Register component globally
        Vue.component(
            componentName,
            // Look for the component options on `.default`, which will
            // exist if the component was exported with `export default`,
            // otherwise fall back to module's root.
            componentConfig.default || componentConfig
        );
    });
}

export default registerComponents;
